<template>
  <banner-page pageName="landing" :image="bannerImage">
    <header>
      <div class="no-overflow d-none d-sm-flex">
        <v-img
          alt="GML Logo"
          class="shrink mt-1"
          contain
          :src="require('../assets/images/gml-logo.png')"
          width="70px"
          height="60px"
        />
      </div>

      <v-spacer class="d-flex d-sm-none " />

      <div class="logo-name no-overflow">
        <p v-if="animationDelay > 0.2" class="dosis slide-in-left">GREENMASTERS LIMITED</p>
      </div>

      <v-spacer class="d-flex d-sm-none " />
    </header>
    <div class="banner-text-container">
      <h1 v-if="animationDelay > 1" class="banner-text slide-in-up-banner-text">Engineering at its peak...</h1>
    </div>
    <div class="downward-link">
      <div class="banner-page-cta">
        <a @click="scrollToServices()">
          <v-icon
          medium
          color="gmWhitish">mdi-chevron-triple-down</v-icon>
        </a>
      </div>
    </div>
  </banner-page>
</template>

<script>
import bannerImage from '../assets/images/home/greenmasters-banner.jpg'

export default {
  name: 'landing',

  data: () => ({
    bannerImage
  }),

  methods: {
    scrollToServices () {
      document.scrollingElement.scrollTo({ top: window.innerHeight * 1.25, left: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
header {
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

header>* {
  padding: 10px;
}

.logo-name {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.logo-name p {
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.6;
  letter-spacing: 0.25rem;
  margin: 0px;
  color: var(--gm-whitish);
}

.banner-text-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 25vh;
  overflow: hidden;
}

.banner-text {
  text-align: center;
  font-family: 'alata';
  font-size: 8vw;
  font-weight: bold;
  line-height: 1.5;
  color: #F6F5F1;
  opacity: 0.95;
  background: -webkit-linear-gradient(45deg, rgba(190, 174, 130, 0.75), #F6F5F1);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.downward-link {
  width: 100vw;
  height: 20vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 80vh;
}

.banner-page-cta {
  width: 40px;
  height: 72px;
  border: 2px solid rgb(53, 113, 51, 0.25);
  border-radius: 50rem;
  animation: blink 2s ease-in-out 0s infinite;
}

.banner-page-cta:hover {
  width: 40px;
  height: 72px;
  border: 2px solid rgb(53, 113, 51);
  border-radius: 50rem;
  animation: none;
}

.banner-page-cta>a {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
</style>
